export default "__VITE_ASSET__Ditb77BD__"